"use strict";
/**
 * This file is auto-generated. Do not modify directly.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Messages = exports.CurrentMessageLocale = exports.LocaleData = exports.getCurrentMessageLocale = exports.getLocalizeFormat = void 0;
/* istanbul ignore next */
function getLocalize() {
    var globalContainer;
    if (typeof process !== 'undefined' && typeof process.release !== 'undefined' && process.release.name === 'node') {
        globalContainer = global;
    }
    else {
        //@ts-ignore
        globalContainer = self;
    }
    var localizeNamespace = globalContainer;
    if (typeof CustomLocalizeNamespace === 'string') {
        localizeNamespace = globalContainer[CustomLocalizeNamespace];
    }
    if (typeof localizeNamespace.Localize === 'undefined') {
        throw Error('The messages.<locale>.js file has not been loaded');
    }
    return localizeNamespace.Localize;
}
;
/* istanbul ignore next */
exports.getLocalizeFormat = function () {
    var localize = getLocalize();
    if (localize.format === undefined) {
        throw Error('The formatters-and-parsers.<locale>.js file has not been loaded');
    }
    return localize.format;
};
/* istanbul ignore next */
exports.getCurrentMessageLocale = function () {
    var localize = getLocalize();
    if (localize.message.currentLocale === undefined) {
        throw Error('The localize.message.currentLocale has not been set');
    }
    return localize.message.currentLocale;
};
/* istanbul ignore next */
exports.LocaleData = { get: function () { return exports.getLocalizeFormat().localeData; } };
/* istanbul ignore next */
exports.CurrentMessageLocale = { get: function () { return exports.getCurrentMessageLocale(); } };
var t = function (k, a) { return getLocalize().msg.formatMessage(k, a); };
exports.Messages = {
    ShowContributors: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/ShowContributors'); },
    HideContributors: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/HideContributors'); },
    Enable: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/Enable'); },
    Disable: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/Disable'); },
    TestConnection: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/TestConnection'); },
    Back: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/Back'); },
    EinsteinDiscoveryDescription: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/EinsteinDiscoveryDescription'); },
    TabPyDescription: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/TabPyDescription'); },
    RServeDescription: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/RServeDescription'); },
    AnalyticsExtensionsAPIDescription: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/AnalyticsExtensionsAPIDescription'); },
    RequireSSL: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/RequireSSL'); },
    SignInWithUsernameAndPassword: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/SignInWithUsernameAndPassword'); },
    Username: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/Username'); },
    Password: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/Password'); },
    Create: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/Create'); },
    Update: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/Update'); },
    Cancel: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/Cancel'); },
    Close: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/Close'); },
    Hostname: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/Hostname'); },
    Port: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/Port'); },
    ConnectionName: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/ConnectionName'); },
    New: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/New'); },
    Edit: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/Edit'); },
    Connection: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/Connection'); },
    AnalyticsExtensionsAPI: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/AnalyticsExtensionsAPI'); },
    NewAnalyticsExtensionConnection: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/NewAnalyticsExtensionConnection'); },
    RServe: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/RServe'); },
    TabPy: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/TabPy'); },
    EinsteinHeader: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/EinsteinHeader'); },
    EinsteinDescription: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/EinsteinDescription'); },
    EinsteinEnabledText: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/EinsteinEnabledText'); },
    LegalDisclaimer: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/LegalDisclaimer'); },
    MenuDescription: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/MenuDescription'); },
    MenuHeader: function () { return t('@tableau__analytics-extensions-settings-dialog-ui/MenuHeader'); },
};
//# sourceMappingURL=Localize.js.map